module.exports = __webpack_public_path__ + "img/login-person.702b8a03.png";